/* Chat del asistente de Gradivus.
   El endpoint y los textos llegan desde el snippet, que los lee de la configuración
   del tema: cambiar de túnel de prueba a servidor de producción no toca este archivo. */
(function () {
  var cfg = window.GVCHAT || {};
  if (!cfg.endpoint) return; // sin servidor configurado, el chat no se muestra

  var boton = document.querySelector('.gvchat-btn');
  var panel = document.querySelector('.gvchat-panel');
  var hilo = document.querySelector('.gvchat-hilo');
  var estado = document.querySelector('.gvchat-estado');
  var form = document.querySelector('.gvchat-form');
  var campo = form.querySelector('input');
  var enviar = form.querySelector('button');
  if (!boton || !panel) return;

  var sesion = null;
  try {
    sesion = sessionStorage.getItem('gvchat_sesion');
    if (!sesion) {
      sesion = (crypto.randomUUID ? crypto.randomUUID() : String(Math.random()).slice(2));
      sessionStorage.setItem('gvchat_sesion', sesion);
    }
  } catch (e) {
    sesion = String(Math.random()).slice(2);
  }

  function pintar(texto, quien) {
    var fila = document.createElement('div');
    fila.className = 'gvchat-fila ' + (quien === 'yo' ? 'gv-yo' : 'gv-ellos');
    var b = document.createElement('div');
    b.className = 'gvchat-burbuja';
    // Los links se construyen como nodos, nunca con innerHTML: el texto viene de fuera.
    texto.split(/(https?:\/\/[^\s]+)/g).forEach(function (parte, i) {
      if (i % 2) {
        var a = document.createElement('a');
        a.href = parte; a.target = '_blank'; a.rel = 'noopener nofollow';
        a.textContent = parte.replace(/^https?:\/\//, '');
        b.appendChild(a);
      } else if (parte) {
        b.appendChild(document.createTextNode(parte));
      }
    });
    fila.appendChild(b);
    hilo.appendChild(fila);
    hilo.scrollTop = hilo.scrollHeight;
  }

  function abrir() {
    panel.hidden = false;
    boton.hidden = true;
    if (!hilo.children.length && cfg.saludo) pintar(cfg.saludo, 'ellos');
    setTimeout(function () { campo.focus(); }, 80);
  }

  function cerrar() {
    panel.hidden = true;
    boton.hidden = false;
  }

  // La ficha de producto tiene una barra de compra que aparece al hacer scroll. El chat
  // se corre hacia arriba usando su ALTURA REAL: si esa barra cambia, esto sigue calzando.
  (function vigilarBarraCompra() {
    var barra = document.querySelector('.sticky-atc');
    if (!barra) return;
    function ajustar() {
      var visible = barra.classList.contains('is-visible');
      document.body.classList.toggle('gvchat-con-barra', visible);
      if (visible) {
        var alto = Math.round(barra.getBoundingClientRect().height);
        if (alto > 0) document.documentElement.style.setProperty('--gvchat-barra', alto + 'px');
      }
    }
    new MutationObserver(ajustar).observe(barra, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', ajustar);
    ajustar();
  })();

  boton.addEventListener('click', abrir);
  panel.querySelector('.gvchat-cerrar').addEventListener('click', cerrar);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) cerrar();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var texto = campo.value.trim();
    if (!texto) return;
    pintar(texto, 'yo');
    campo.value = '';
    enviar.disabled = true;
    estado.textContent = 'escribiendo...';

    var cuerpo = { sesion: sesion, texto: texto };
    // Qué producto está mirando: el agente responde sobre eso sin que lo tenga que nombrar.
    if (cfg.producto) cuerpo.contexto = cfg.producto;

    fetch(cfg.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cuerpo)
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var partes = (d.respuesta || '').split('\n\n').filter(function (p) { return p.trim(); });
        if (!partes.length) partes = ['No pude responder ahora. Escríbenos y te respondemos.'];
        return mostrarEnOrden(partes);
      })
      .catch(function () {
        pintar('Se cortó la conexión. Intenta de nuevo en un momento.', 'ellos');
      })
      .then(function () {
        estado.textContent = '';
        enviar.disabled = false;
        campo.focus();
      });
  });

  // Una burbuja a la vez, con "escribiendo..." entre medio: al menos un segundo, más si el
  // mensaje que viene es largo. Todas de golpe se leen como máquina.
  function pausaPara(texto) {
    return Math.max(1200, Math.min(3000, 800 + texto.length * 12));
  }

  function mostrarEnOrden(partes) {
    return partes.reduce(function (cadena, p, i) {
      return cadena.then(function () {
        if (!i) { pintar(p.trim(), 'ellos'); return; }
        estado.textContent = 'escribiendo...';
        return new Promise(function (listo) {
          setTimeout(function () { pintar(p.trim(), 'ellos'); listo(); }, pausaPara(p));
        });
      });
    }, Promise.resolve());
  }
})();
